export const AUTH_URL = '/auth';
export const BOOK_MASTER_URL = '/bookMaster';
export const AUTHOR_MASTER_URL = '/authorMaster';
export const CATEGORY_MASTER_URL = '/categoryMaster';
export const LANGUAGE_MASTER_URL = '/languageMaster';
export const CLOSURE_REASON_MASTER_URL = '/closureReasonMaster';
export const MEMBER_MGMT_URL = '/memberManagement';
export const USER_MGMT_URL = '/userManagement';
export const ROUTE_MASTER_URL = '/routeMaster';
export const STATS_URL = '/stats';
export const TRANSACTION_URL = '/transaction';
export const CENTERS_MASTER_URL = '/centersMaster';
export const CENTER_TRNX_URL = '/centerTrnxMaster';
export const BARCODE_LABEL_URL = '/barcodeLabel';
export const BOOK_URL = '/book';
export const BOOK_INVENTORY_URL = '/bookInventory';
export const ONBOARD_URL = '/onboard';
export const SYSPARAM_URL = '/sysParam';
export const MEMBER_URL = '/member';
export const USER_URL = '/user';
export const FINANCIAL_TRNX_URL = '/financialTransactions';
export const BOOK_CLAIMS_URL    = '/bookClaims';
export const ICT_URL = '/interCenterTransfer';
export const DAILY_SUMMARY_URL = '/dailySummary';
